<template>
  <a-empty v-if="!isEdit"
           image="https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original"
           :image-style="{
      height: '60px',
    }"
  >
    <span slot="description"><a @click="toAdd('/expertInfo/expertLoginAdd')">您还未录入专家入库信息</a> </span>
    <a-button @click="toAdd('/expertInfo/expertLoginAdd')" type="primary">
      去申请入库
    </a-button>
  </a-empty>
  <expert-form v-else ref="eForm" :form="form" :isEdit="isEdit" :spinLoading="spinLoading" @afterSaveToUrl="onViewUrl"/>
</template>

<script>

import expertForm from '@/epp/expertmain/expertInfo/common/ExpertForm.vue'
import { GetExpertByUserId } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import moment from 'moment'

export default {
  name: 'ExpertLoginEdit',
  components: {
    expertForm
  },
  data () {
    return {
      id: this.$route.query.id,
      form: {},
      spinLoading: false,
      isEdit: true,
    }
  },
  computed: {},
  created () {
    this.getExpert()
  },
  methods: {
    async getExpert () {
      try {
        this.spinLoading = true
        let res = await GetExpertByUserId()
        if (!res.result) {
          this.isEdit = false
        }
        this.form = res.result
        this.form.birthdate = this.form.birthdate ? moment(this.form.birthdate) : moment()
        this.form.retireDate = this.form.retireDate && moment(this.form.retireDate)
        if (this.form.otherSpecificProfessionalTitle) {
          this.form.specificProfessionalTitle = this.form.specificProfessionalTitle?this.form.specificProfessionalTitle + '；' + this.form.otherSpecificProfessionalTitle:this.form.otherSpecificProfessionalTitle
        }
      } catch (e) {
        console.log(e.message)
        this.isEdit = false
      } finally {
        this.spinLoading = false
      }
    },
    toAdd(target){
      this.$router.push({ path: target})
    },
    onViewUrl(id){
      this.$router.push({
        path: '/expertInfo/expertLoginView'
      })
    }
  }
}
</script>

<style></style>
